import { CheckCircle } from '@mui/icons-material';
import { Button, CardContent, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import moment from 'moment';
import SimpleCard from '../../../../../components/SimpleCard';
import { APP_ROUTES } from '../../../../../constants/app-routes';

export default function Success() {
  const navigate = useNavigate();
  const { currentBooking } = useSelector((store) => store.vendorRetail);

  const handleBackToDashboard = () => {
    navigate(APP_ROUTES.DASHBOARD);
  };

  return (
    <div>
      <Grid container justifyContent="center" marginBottom={2}>
        <Grid item>
          <Typography fontWeight="bold">Booking Confirmed!</Typography>
        </Grid>
      </Grid>

      <SimpleCard variant="outlined">
        <CardContent>
          <Grid container justifyContent="center" textAlign="center">
            <Grid item xs={12}>
              <CheckCircle
                sx={{
                  fontSize: 80,
                  color: '#3c99ba',
                  marginBottom: 2,
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h5" fontWeight="bold" marginBottom={2}>
                Your retail space booking is confirmed!
              </Typography>

              <Typography variant="body1" color="text.secondary" marginBottom={3}>
                Thank you for your payment. Your booking details have been saved.
              </Typography>

              {currentBooking && (
                <div style={{ marginBottom: '2rem' }}>
                  <Typography variant="body2" color="text.secondary">
                    <strong>Booking Date:</strong>{' '}
                    {moment(currentBooking.booking_date).format('MMM DD, YYYY')}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    <strong>Time:</strong> {currentBooking.start_time} - {currentBooking.end_time}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    <strong>Duration:</strong> {currentBooking.duration_hours} hour(s)
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    <strong>Total Paid:</strong> $
                    {currentBooking.total_amount_paid || currentBooking.total_price}
                  </Typography>
                </div>
              )}

              <Typography variant="body2" color="text.secondary" marginBottom={3}>
                You can view and manage your bookings from your dashboard.
              </Typography>

              <Button
                variant="contained"
                size="large"
                onClick={handleBackToDashboard}
                sx={{
                  bgcolor: '#EE7B57',
                  '&:hover': {
                    bgcolor: '#d66a47',
                  },
                  px: 4,
                  py: 1.5,
                }}>
                Back to Dashboard
              </Button>
            </Grid>
          </Grid>
        </CardContent>
      </SimpleCard>
    </div>
  );
}
